import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ToasterComponent } from './toaster.component';

@NgModule({
  declarations: [ToasterComponent],
  imports: [MatSnackBarModule, CommonModule],
  exports: [ToasterComponent]
})
export class CustomToasterModule {
}
